import { AsyncComponent } from '@frontend/elements';
import { lazy } from 'react';
import { Route } from 'react-router-dom';

const LabelOverview = lazy(() => import('./label-overview/label-overview'));
const LabelDetail = lazy(() => import('./label-detail/label-detail.component'));

export function LabelRoutes() {
    return (
        <Route path='labels'>
            <Route
                index
                element={
                    <AsyncComponent>
                        <LabelOverview />
                    </AsyncComponent>
                }
            />
            <Route path=':labelId'>
                <Route
                    index
                    path='detail'
                    element={
                        <AsyncComponent>
                            <LabelDetail />
                        </AsyncComponent>
                    }
                />
            </Route>
        </Route>
    );
}

export default LabelRoutes;
